import classes from './CSVFile.module.css';
import PropTypes from 'prop-types';
import csvImage from './assets/icon-csv.svg';
import IconButton from 'Components/Atoms/IconButtonBare';
import Icon from 'Components/Atoms/Icon/Icon';
import { formatLongDate, formatFileSize } from 'Utils/formatters';

export default function CSVFile(props) {
    const { file, onDelete } = props;

    const handleDelete = () => {
        onDelete(file);
    };

    return (
        <div className={classes.file}>
            <div className={classes.preview}>
                <img src={csvImage} alt={file.type} />
            </div>
            <div className={classes.info}>
                <div className={classes.name}>{file.name}</div>

                <div className={classes.details}>
                    <span className={classes.size}>{formatFileSize(file.size)}</span>
                    <span className={classes.separator}>·</span>
                    <span className={classes.date}>{formatLongDate(file.lastModifiedDate)}</span>
                </div>
            </div>

            <IconButton onClick={handleDelete}>
                <Icon name="trash" size={20} color="#868686" />
            </IconButton>
        </div>
    );
}

CSVFile.propTypes = {
    file: PropTypes.shape({
        name: PropTypes.string.isRequired,
        size: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired,
        lastModifiedDate: PropTypes.instanceOf(Date).isRequired,
    }).isRequired,
    onDelete: PropTypes.func.isRequired,
};
